"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.rootEpics = exports.getRootAppReducers = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/concat"));

var _connectedReactRouter = require("connected-react-router");

var _applicationRegistry = require("../../App/redux/applicationRegistry");

var _redux = require("../../AppSuite/redux");

var _redux2 = require("../../FeatureFlags/redux");

var _redux3 = require("../../Notifications/redux");

var _redux4 = require("../../Options/redux");

var _redux5 = require("../../Search/redux");

var _redux6 = require("../../User/redux");

var _nav = require("./nav");

var _context;

var optionalModules = {};
var epics = (0, _concat.default)(_context = _applicationRegistry.applicationRegistry.getEpics()).call(_context, _redux4.optionsRegistry.getEpics(), _redux6.userRegistry.getEpics(), _redux5.searchRegistry.getEpics(), _redux2.featureFlagsRegistry.getEpics(), _redux3.notificationsRegistry.getEpics());

if (process.env.APP_SUITE_ENABLED === 'true') {
  optionalModules = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, optionalModules), {}, {
    appSuite: _redux.appSuiteRegistry.getReducer()
  });
  epics = (0, _concat.default)(epics).call(epics, _redux.appSuiteRegistry.getEpics());
}

var getRootAppReducers = function getRootAppReducers(history) {
  return (0, _objectSpread2.default)({
    nav: _nav.navReducers,
    router: (0, _connectedReactRouter.connectRouter)(history),
    application: _applicationRegistry.applicationRegistry.getReducer(),
    options: _redux4.optionsRegistry.getReducer(),
    user: _redux6.userRegistry.getReducer(),
    search: _redux5.searchRegistry.getReducer(),
    featureFlags: _redux2.featureFlagsRegistry.getReducer(),
    notifications: _redux3.notificationsRegistry.getReducer()
  }, optionalModules);
};

exports.getRootAppReducers = getRootAppReducers;
var rootEpics = epics;
exports.rootEpics = rootEpics;